import { api } from '../api/client';

/**
 * Naming convention for every record the guided lessons create. The backend
 * cleanup endpoint deletes exactly the records whose name starts with
 * "TRAINING " (this prefix + a space, CASE-SENSITIVE via GLOB) — keep in sync
 * with backend/src/routes/lessons.ts and isPracticeName below.
 */
export const PRACTICE_PREFIX = 'TRAINING';

export interface PracticeCounts {
  prefix?: string;
  customers: number;
  orders: number;
  technicians: number;
  equipment: number;
  consumables: number;
  accessories: number;
  /** Practice equipment left in place because the caller is not an admin. */
  equipmentSkipped?: number;
}

export function totalPractice(c: PracticeCounts): number {
  return c.customers + c.orders + c.technicians + c.equipment + c.consumables + c.accessories;
}

export const getPracticeData = () => api.get<PracticeCounts>('/lessons/practice-data');
export const cleanupPracticeData = () => api.post<PracticeCounts>('/lessons/practice-cleanup');

/**
 * True when the typed value follows the practice naming convention. Must
 * mirror the backend cleanup matcher exactly (case-sensitive, prefix + space):
 * anything looser would let a lesson create a record the cleanup won't delete.
 */
export const isPracticeName = (v: string) => v.startsWith(`${PRACTICE_PREFIX} `) && v.trim().length > PRACTICE_PREFIX.length;
